// extracted by mini-css-extract-plugin
export default {"app":"App_app__OUvTQ","ui":"App_ui__cw3sD","segment":"App_segment__231ny","active":"App_active__xw7IT"};